export const OFFLINE_LABEL = 'Offline';
